// extracted by css-extract-rspack-plugin
export default {"RedirectView":"style-module__RedirectView___yA6mZ","redirectView":"style-module__RedirectView___yA6mZ","action":"style-module__action___v4SPs style-module__action___lOV36"};